import { render, staticRenderFns } from "./CommonModalWithPreset.vue?vue&type=template&id=72c197c0&lang=pug&"
import script from "./CommonModalWithPreset.vue?vue&type=script&lang=ts&"
export * from "./CommonModalWithPreset.vue?vue&type=script&lang=ts&"
import style0 from "./CommonModalWithPreset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports